export default {
  namespaced: true,
  getters: {
    getItems: (_state, _getters, rootState, rootGetters) => rootGetters['iscsi/targetGroups/getAllPath']
      .filter(lun => lun && rootState.routes.params.nodeId === lun.node_id && lun.isActive)
      .map(lun => ({
        id: lun.volume.id,
        ...lun,
        name: lun.lunId,
      })),
    getItemById: (_state, _getters) => id => _getters.getItems.find(item => item.id === id)
  }
};
